module.exports = __webpack_public_path__ + "static/goal-27aecd6cc129913b43eba88b6abe2665.png";